module.exports = "/images/veheri-hero-img.jpg?b21c649380a8daedcd0d246750abe577";